import wixWindow from 'wix-window';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

$w.onReady(function () {

    $w('#btnBrochure').onClick(() => {
		//console.log ('btn presentation clicked')
        addLogActivity('Dairy-Brochure');
		wixWindow.openLightbox("ברושורים מועצת החלב");

       
		
    });

	

	

	$w('#btnContactUs').onClick(() => {
		console.log ('btn contact us')
        addLogActivity('Dairy-contact-us');
        wixLocation.to("mailto:Aviva@laniado.co.il?subject=Lead%20from%20PharmaDigitali");
		
    });





})

async function addLogActivity(description) {
    let userId = await wixUsers.currentUser.id;
    let referrer = wixWindow.referrer; // "http://somesite.com"
    let deviceType = wixWindow.formFactor; // "Mobile"
    let url = wixLocation.url;
    //let description = 'Contact-Us';

    //let user = await wixUsersBackend.getUser(userId);
    //onsole.log ('user details: ', user)

    let toInsert = {
        "userId": userId,
        "referrer": referrer,
        "deviceType": deviceType,
        //"referrer":   referrer,
        "url": url,
        "description": description

    };

    wixData.insert("log", toInsert)
        .then((results) => {
             console.log('Info wrote to log data: ', results)
            //let item = results; //see item below
        })
        .catch((err) => {
            let errorMsg = err;
        })
}

